import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';

export interface TabItem {
  id: string;
  label: string;
  icon: string;
  disabled?: boolean;
}

@Component({
  selector: 'app-tabs',
  templateUrl: './tabs.component.html',
  styleUrls: ['./tabs.component.css']
})
export class TabsComponent implements OnInit {
  @Input() tabs: TabItem[] = [];
  @Input() activeTab: string = '';
  @Output() tabChange = new EventEmitter<string>();

  constructor() { }

  ngOnInit(): void {
    if (!this.activeTab && this.tabs.length > 0) {
      this.activeTab = this.tabs[0].id;
    }
  }

  setActiveTab(tabId: string) {
    if (this.isTabDisabled(tabId)) return;
    this.activeTab = tabId;
    this.tabChange.emit(tabId);
  }

  isTabActive(tabId: string): boolean {
    return this.activeTab === tabId;
  }

  isTabDisabled(tabId: string): boolean {
    const tab = this.tabs.find(t => t.id === tabId);
    return tab?.disabled || false;
  }
}
